import { withStyles } from '@material-ui/core';

import SortableItem from './component';
import styles from './styles';

export default withStyles(styles)(SortableItem);
